import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { WALLET_ACCOUNTING_SYNC_BASE_PATH } from '../../constants';

interface AccountingSyncBreadcrumbProps {
  detailLabel?: string;
}

export const AccountingSyncBreadcrumb = ({ detailLabel }: AccountingSyncBreadcrumbProps) => {
  const { t } = useTranslation('accountingSyncModule');
  const { t: tMenu } = useTranslation('menu');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [
      {
        label: tMenu('reportes_contabilidad'),
        path: '/reports/orders-without-weight',
      },
      {
        label: t('breadcrumbs.accounting_sync'),
        path: WALLET_ACCOUNTING_SYNC_BASE_PATH,
      },
    ];

    if (detailLabel) {
      items.push({ label: detailLabel });
    }

    return items;
  }, [detailLabel, t, tMenu]);

  usePageNavigation({ breadcrumbs });

  return null;
};
